// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3UWz5","header":"ClearentDisclaimer_header__3-IBL","inner":"ClearentDisclaimer_inner__38vo3"};